import { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { PrinterFill, XCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../../components/CustomButton'
import apinode from '../../../../services/apinode'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export function ModalPrintLabel({ isOpen, onClose, codendereco }) {
  const [tipo_impressao, setTipoImpressao] = useState('')
  const [imprimir_sku, setImprimirSku] = useState(false)
  const [isPrintRequestLoading, setIsPrintRequestLoading] = useState(false)

  async function handlePrintLabel() {
    try {
      setIsPrintRequestLoading(true)

      await apinode.post(
        `/wms-print-label/${codendereco}/${localStorage.idconta}`,
        {
          tipo_impressao,
          imprimir_sku,
        },
      )

      toast.success('Etiqueta enviada para a fila de impressão!')
      onClose()
    } catch (err) {
      sendErrorApiMessage('Não foi possível imprimir a etiqueta!')
    } finally {
      setIsPrintRequestLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header>
        <Modal.Title>Imprimir Etiqueta</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={6}>
            <Form.Label>Tipo de Impressão</Form.Label>
            <Form.Select
              value={tipo_impressao}
              onChange={(e) => setTipoImpressao(e.target.value)}
            >
              <option value="">Sem Figura</option>
              <option value="S">Superior</option>
              <option value="I">Inferior</option>
              <option value="E">Esquerda</option>
              <option value="D">Direita</option>
            </Form.Select>
          </Col>

          <Col xs={6}>
            <Form.Label>Imprimir SKU</Form.Label>
            <Form.Check
              checked={imprimir_sku}
              onClick={(e) => {
                if (e.target.checked) {
                  setImprimirSku(true)
                } else {
                  setImprimirSku(false)
                }
              }}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Imprimir"
          color="#229954"
          onClick={handlePrintLabel}
          isLoading={isPrintRequestLoading}
          isLoadingText="Imprimindo..."
        >
          <PrinterFill />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          color="#b03a2e"
          isDisabled={isPrintRequestLoading}
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
